import { ListPageSkeleton, SidePanelSkeleton } from '@/components/PageSkeleton';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * 文案库页面骨架。
 *
 * 真实结构：`flex h-full w-full gap-x-5 overflow-hidden`
 * → 左：`aside w-62`（h-12 标题「文案文件夹」+ 可滚动 `FolderTree`）
 * → 右：`main flex min-w-0 flex-1 flex-col`，标题行（标题 / 列表-网格切换 / 添加文案）
 *   + `mt-2 flex-1` 内的 `TableCardLayout`（12 列）。
 */
export function TextLibrarySkeleton() {
  return (
    <div className="flex h-full w-full gap-x-5 overflow-hidden">
      {/* 左侧文案文件夹 */}
      <SidePanelSkeleton widthClassName="w-62" itemCount={10} itemHeight={32} />

      <main className="flex min-w-0 flex-1 flex-col">
        {/* 标题 + 列表/网格切换 + 添加文案 */}
        <div className="flex flex-row items-center gap-x-5">
          <Skeleton className="h-5.5 w-24" />
          <div className="ml-auto flex h-auto items-center gap-1 rounded-md bg-muted p-1.25">
            <Skeleton className="size-8 rounded-sm bg-[#e4e4e4] dark:bg-[#3a3a3a]" />
            <Skeleton className="size-8 rounded-sm bg-[#e4e4e4] dark:bg-[#3a3a3a]" />
          </div>
          <Skeleton className="h-9 w-24" />
        </div>

        {/* 文案列表卡片（实测 10 列：勾选 + 文案/文案长度/操作人/更新人/消耗/展示数/千次展示成本/点击数/操作） */}
        <div className="mt-4 min-h-0 flex-1 overflow-hidden">
          <ListPageSkeleton columnCount={10} />
        </div>
      </main>
    </div>
  );
}

export default TextLibrarySkeleton;
